import { AsyncDirective as LitAsyncDirective } from 'lit/async-directive.js';
import { directive } from 'lit/directive.js';
import { asapScheduler, observeOn } from 'rxjs';
import { objectsEqual } from '../../../utils';
import { listenChangesByPath } from '../i18n';
const stubText = '';
class TranslateDirective extends LitAsyncDirective {
    render(path, context) {
        if (this.subscription && this.lastPath === path && objectsEqual(this.lastContext, context)) {
            return this.lastValue ?? stubText;
        }
        else {
            this.disconnected();
        }
        this.subscription = listenChangesByPath(path, context)
            .pipe(observeOn(asapScheduler))
            .subscribe((value) => {
            this.setValue(value);
            this.lastValue = value;
            this.lastPath = path;
            this.lastContext = context;
        });
        return this.lastValue ?? stubText;
    }
    disconnected() {
        this.subscription?.unsubscribe();
    }
}
export const translate = directive(TranslateDirective);
//# sourceMappingURL=translate-directive.js.map